import { FunctionField, SelectField, useTranslate } from 'react-admin';
import { Box } from '@mui/material';
import { operatorStatusChoices } from '@/components/global/options/selectOptions.jsx';
import StatusIconWithTooltip from '@/components/transaction/StatusIconWithTooltip.jsx';

const TransactionOperatorStatusField = ({ source = 'operatorStatus' }) => {
    const translate = useTranslate();
    return (
        <FunctionField
            source={source}
            render={record => {
                let status = operatorStatusChoices(translate).find(s => s.id === record.operatorStatus);
                return (
                    <Box display='flex' alignItems='center'>
                        <StatusIconWithTooltip icon={status.icon} tooltipContent={record.operatorStatusInfo} />
                        <SelectField
                            source='operatorStatus'
                            choices={operatorStatusChoices(translate).map(choice => ({ id: choice.id, name: choice.name }))}
                            variant='h6'
                        />
                    </Box>
                );
            }}
        />
    );
};

export default TransactionOperatorStatusField;
